export const produceShops = [ '2F-B-1', '2F-C', '3A-1-1', '3A-1-2', '3A-1-3', '3A-2-1', '3A-2-2', '3A-2-3', '3F-C-1', '3F-C-2']

export function add0 (val) {
	return val>10?val:'0'+val
}

export function getEndDay(year, month) {
	const date = new Date(year, month -1, '01')
	date.setDate(1);
	date.setMonth(date.getMonth() + 1);
	const cdate = new Date(date.getTime() - 1000*60*60*24);
	
	const y = cdate.getFullYear()
	const m = cdate.getMonth() + 1
	const d = cdate.getDate()
	return y + '-' + add0(m) + '-' + add0(d)
}